var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 140,
    viewBox: "0 0 187 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87109 139L186.002 139",
    stroke: "#D7D7D7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 86.7513L12.1063 94.6388C25.9686 100.512 31.3003 91.3212 41.9346 80.6841C54.3275 70.0441 58.8954 90.4337 68.9071 106.167C83.2862 130.022 88.6313 101.183 99.6874 73.4033C112.235 35.6624 117.297 71.2122 127.612 97.6724C140.776 130.187 150.142 76.1338 158.709 38.2132C167.277 0.29259 181.715 59.4486 185.999 70.3697",
    stroke: "#D7D7D7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V139",
    stroke: "#D7D7D7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartLoading);
export default __webpack_public_path__ + "static/media/barChartLoading.ae85901c5f82554e06bc65154ae6efaa.svg";
export { ForwardRef as ReactComponent };